import { httpClient } from './http-client';

export interface Holding {
  symbol: string;
  account_id: string;
  account_name: string;
  owner_label: string;
  shares: string;
  book_cost: string;
  acb_per_share: string;
  lot_count: number;
  price: string;
  /** False when no quote was available; market fields are then meaningless. */
  has_price: boolean;
  market_value: string;
  gain_loss: string;
  gain_pct: string;
}

export interface AllocationSlice {
  key: string;
  value: string;
  percent: string;
  count: number;
}

export interface Concentration {
  top_weight_pct: string;
  top_symbol: string;
  top5_weight_pct: string;
  /** Herfindahl-Hirschman Index over position weights, 0–10000. */
  hhi: string;
  position_count: number;
  symbols_missing_price: string[];
}

export interface PortfolioTotals {
  book_cost: string;
  market_value: string;
  gain_loss: string;
  gain_pct: string;
  priced_count: number;
  holding_count: number;
}

export interface PortfolioResponse {
  holdings: Holding[];
  totals: PortfolioTotals;
  by_symbol: AllocationSlice[];
  by_account: AllocationSlice[];
  by_owner: AllocationSlice[];
  concentration: Concentration;
  /** Always "descriptive_only" — this API never emits buy/sell signals. */
  analysis_type: string;
}

class PortfolioService {
  static async get(): Promise<PortfolioResponse> {
    return httpClient.get<PortfolioResponse>('/portfolio');
  }
}

export const portfolioService = PortfolioService;

/**
 * Plain-language reading of an HHI score.
 *
 * Describes the portfolio's structure; deliberately does not suggest an action.
 */
export const hhiLabel = (hhi: number): string => {
  if (hhi >= 2500) return 'Highly concentrated';
  if (hhi >= 1500) return 'Moderately concentrated';
  return 'Diversified';
};
